<template>
  <div>
    <router-view></router-view>
    <vue-progress-bar></vue-progress-bar>
    <notifications group="main" />
  </div>
</template>

<script>
import router from '@/router'
import store from '@/store'

router.beforeEach((to, from, next) => {
  if (to.meta.auth) { // check the meta field
    if (store.state.isLogged) { // check if the user is authenticated
      next() // the next method allow the user to continue to the router
    } else {
      next({name: 'login'}) // Redirect the user to the main page
    }
  } else {
    next()
  }
})

export default {
  name: 'app',
  mounted: function () {
    this.$nextTick(function () {
      this.$http.get(process.env.API_URL + '/auth/check', this.data).then((response) => {
      },
      (response) => {
        if (response.status === 403) {
          console.log('nextTick trigger redirect to login')
          // this.$eventHub.$emit('redirectToLogin')
        }
      })
    })
  }
}
</script>

<style>
/* Import Font Awesome Icons Set */
$fa-font-path: '~font-awesome/fonts/';
@import '~font-awesome/css/font-awesome.min.css';
/* Import Simple Line Icons Set */
$simple-line-font-path: '~simple-line-icons/fonts/';
@import '~simple-line-icons/css/simple-line-icons.css';
/* Import Bootstrap Vue Styles */
@import '~bootstrap-vue/dist/bootstrap-vue.css';
/* Import autocomplete css */
@import '~vue2-autocomplete-js/dist/style/vue2-autocomplete.css';
</style>
<style lang="scss">
// Import Main styles for this application
@import './scss/style';
</style>



// WEBPACK FOOTER //
// App.vue?a2033b5c